 <template>
  <div>
    <v-row>
      <v-col cols="4" v-for="(year) in lastFiveYears" :key="year">
          <v-text-field   
           :disabled="!isAdmin"               
            prefix="$"
            suffix="MXN"
            dense  
            v-model="debtValues[year]"
            :label="`Adeudo ${year}`"
          ></v-text-field>
        </v-col>    
    </v-row>
  </div>
</template>
 
<script>
export default { 
  props: {
    infoUser: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {     
      lastFiveYears: null,
    };
  },
  mounted() {    
    if (this.infoUser != null) {
      this.lastFiveYears= this.getLastFiveYears();
      this.debtValues = this.infoUser.debts.reduce((acc, d) => {
        acc[d.year] = d.debt;
        return acc;
      }, {});   
    } 
  },
  watch: {
    infoUser() {
      this.lastFiveYears= this.getLastFiveYears();
      this.debtValues = this.infoUser.debts.reduce((acc, d) => {
        acc[d.year] = d.debt;
        return acc;
      }, {});     
    },
  },  
  methods: {    
    getLastFiveYears () {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1;
      const startYear = currentMonth >= 11 ? currentYear + 1 : currentYear;
      return this.lastFiveYears = Array.from({ length: 5 }, (_, i) => startYear - (4 - i));
    },    
  },
};
</script>
<style>
.theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
    color: rgba(0, 0, 0, 1) !important;
}
</style>


<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>


